import React, { forwardRef, memo } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Editor = forwardRef(({ content, onChange }, ref) => {
    return (
        <ReactQuill ref={ref} value={content} onChange={onChange} style={SandBoxStyle} />
    );
});

const ReactQuillEditor = memo(Editor, (prevProps, nextProps) => {
    return prevProps.content === nextProps.content;
});

export default ReactQuillEditor

const SandBoxStyle = {
    width: "100%",
    height: "100%",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    borderRadius: "12px",
    overflow: "auto",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    marginBottom: "1rem",
  };